// extracted by mini-css-extract-plugin
export var switchBtn = "theme-switcher-module--switchBtn--74645";
export var switchIcon = "theme-switcher-module--switchIcon--3dad4";